import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const crystalLakesMetadata = {
  id: 'crystal-lakes',
  name: 'Crystal Lakes',
  description:
    'A polished inland championship resort winding through reflective lakes, crossing streams and rolling mixed woodland.',
  environmentPreset: 'crystal-lake-district',
  metadata: {
    location: 'Great Lakes',
    regionType: 'rolling inland lake district',
    difficulty: 81,
    typicalWind: [3, 14] as const,
    greenSpeed: [10.5, 11] as const,
    firmness: 'medium-soft' as const,
    primaryChallenge: 'Lake, stream and woodland championship golf',
    signatureHoles: [4, 7, 12, 18],
    tournamentEventId: 'event-15',
    previewTheme: 'crystal-lake-district',
    environmentPalette: {
      fairway: '#5f9658',
      rough: '#426b45',
      bunker: '#d8c58c',
      water: '#3d91ab',
      haze: '#b9d5d6',
      sky: '#84b8d5',
      rock: '#78857d',
      wasteArea: '#c7ad78',
    },
    vegetationStyle: 'mixed birch, maple and pine, medium density',
    terrainStyle: terrainPreset('crystal-lake-district', 20, 150, 1.1).id,
    sunlightDirection: 'southeast clear daylight',
    distantScenery: 'wooded ridges, waterfalls and glassy lakes',
    waterStyle: 'high-reflection clear freshwater',
    eventPresentation: {
      accentColor: '#84b8d5',
      mark: 'CRYSTAL',
      subtitle: 'Choose the waterline',
      loadingCopy: 'Every inlet changes the angle',
      identityLine: 'Lake, stream and woodland championship golf',
      tierLabel: 'STANDARD',
    },
    wasteArea: { carryMultiplier: 0.91, consistencyMultiplier: 0.88, rollMultiplier: 0.72 },
  },
};
const pars = [4, 5, 4, 3, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4];
const yards = [
  420, 550, 430, 175, 445, 405, 190, 560, 425, 450, 165, 570, 410, 435, 205, 535, 415, 465,
];
const names = [
  'Glass Shore',
  'Upper Falls',
  'Lake Turn',
  'Inlet',
  'Mirror Dogleg',
  'Birch Bank',
  'Clear Carry',
  'Stream Decision',
  'Resort Rise',
  'Twin Pines',
  'Cascade',
  'Layup Crossing',
  'Woodland Water',
  'Reflections',
  'Narrow Blue',
  'Terraced Lake',
  'Last Stream',
  'Between Waters',
];
const options: Partial<HolePlan>[] = [];
options[2] = {
  water: 'right',
  landingZones: [{ distance: 270, width: 50, preferredSide: 'left' }],
};
options[3] = { water: 'carry', greenRadius: 20 };
options[6] = { water: 'carry' };
options[7] = { water: 'carry', splitFairway: true };
options[11] = {
  water: 'carry',
  landingZones: [{ distance: 280, width: 48, preferredSide: 'right' }],
};
options[17] = { water: 'green', greenRadius: 19 };
export const createCrystalLakesDocument = () =>
  authorCourse({
    ...crystalLakesMetadata,
    plans: plans(names, pars, yards, options).map((plan) => ({
      ...plan,
      trees: plan.trees ?? 5,
      rocks: plan.rocks ?? 0,
    })),
  });
